angular.module('b2bLoginApp').directive('regionTreeRowsWidget', function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        scope: {
            regions: '=',
            level: '=',
            types: '=',
            subscriptions: '=',
            company: '=',
            update: '=',
            click: '=',
            dropdownOptions: '=',
            freetrialOptions: '='
        },
        templateUrl: 'areas/tree-widget.html'
    };
});
